/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Component that is used for rendering course title
 */
class CourseInfo extends PureComponent {
    static propTypes = {
        course: PropTypes.shape({
            /**
             * Unique id
             */
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string
            ]).isRequired,
            /**
             * Is course abandoned
             */
            abandoned: PropTypes.bool.isRequired,
            /**
             * Is Course all Weather
             */
            allWeather: PropTypes.bool.isRequired,
            /**
             * Surface type of AW track
             */
            surfaceType: PropTypes.string.isRequired,
            /**
             * Course colour
             * If there is no colour, there will be no specific class
             */
            colour: PropTypes.number,
            /**
             * Course name
             */
            name: PropTypes.string.isRequired,
            /**
             * Course country code
             */
            countryCode: PropTypes.string.isRequired,
            /**
             * Course meeting url
             */
            meetingUrl: PropTypes.string.isRequired,
            /**
             * Course hashname
             */
            hashName: PropTypes.string.isRequired,
            /**
             * Course type
             */
            meetingTypeCode: PropTypes.string.isRequired,
            /**
             * List of races
             */
            races: PropTypes.arrayOf(
                PropTypes.shape({
                    /**
                     * Is race abandoned
                     */
                    abandoned: PropTypes.bool.isRequired,
                    /**
                     * Race result
                     */
                    result: PropTypes.bool.isRequired,
                    /**
                     * Race time
                     */
                    link: PropTypes.string.isRequired,
                    /**
                     * Race title
                     */
                    title: PropTypes.string.isRequired,
                    /**
                     * Race time
                     */
                    time: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.number
                    ]),
                    /**
                     * Race number of runners
                     */
                    runners: PropTypes.number.isRequired,
                    /**
                     * Has race offers
                     */
                    hasRaceOffers: PropTypes.bool.isRequired,
                    /**
                     * Is next race
                     */
                    isNextRace: PropTypes.bool.isRequired,
                    /**
                     * Is next race less than 30 min away
                     */
                    isThirthyMinToNextRace: PropTypes.bool.isRequired,
                    /**
                     * Is Race started
                     */
                    started: PropTypes.bool.isRequired,
                })
            )
        }).isRequired,
        /**
         * Date of the course
         */
        date: PropTypes.string.isRequired
    };

    getCourseDetails = (course) => {
        const { meetingTypeCode, races, allWeather, surfaceType } = course;
        const allWeatherLabel = allWeather ?
        `${surfaceType && surfaceType.length > 0 ? surfaceType : 'All-weather'} | ` :
        '';
        const raceLabel = races.length > 1 ? 'races' : 'race';

        return (
            <span className="rh-cardsMatrix__courseDetails">
                {`${meetingTypeCode} | ${allWeatherLabel}${races.length} ${raceLabel}`}
            </span>
        );
    }

    getCourseInfo = (course) => {
        const { name, countryCode } = course;
        return (
            <span className="rh-cardsMatrix__courseTitleContainer">
                <span className="rh-cardsMatrix__courseName">{name}</span>
                { countryCode !== 'GB' && <span> ({countryCode})</span> }
            </span>
        );
    }

    render() {
        const { course, date } = this.props;
        const courseClass = classNames(
            'rh-cardsMatrix__courseTitle',
            {
                'ui-link': course.races.length > 1
            }
        );
        const linkSmClass = classNames('hidden-sm-down', courseClass);
        const linkMdClass = classNames('hidden-md-up', courseClass);
        const courseUrl = `/racecards/
            ${date && date.length > 0 ? `${date}/` : ''}
            #${course.hashName}`.replace(/\s+/g, '');
        const courseDetails = this.getCourseDetails(course);
        const curseTitle = this.getCourseInfo(course);

        return (
            <div className="rh-cardsMatrix__courseInfo" ref={(node) => { this.cell = node; }}>
                {
                    course.races.length === 1 ?
                        <span
                            className={courseClass}
                            ref={(node) => { this.span = node; }}
                        >
                            {curseTitle}
                        </span> :
                        <span>
                            <a
                                className={linkSmClass}
                                href={course.meetingUrl}
                                ref={(node) => { this.link = node; }}
                            >
                                {curseTitle}
                            </a>
                            <a
                                className={linkMdClass}
                                href={courseUrl}
                            >
                                {curseTitle}
                            </a>
                        </span>
                }
                { !course.abandoned && courseDetails }
            </div>
        );
    }
}

export { CourseInfo as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CourseInfo/CourseInfo.js